module.exports = __webpack_public_path__ + "achtergrond-winkel.8d47a2e1fb98224480e6.jpg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/images/achtergrond-winkel.jpg
// module id = ../../../../../src/assets/images/achtergrond-winkel.jpg
// module chunks = styles